/**
 *
 * Styles for OfferPriceAndPaymentInfo
 *
 */

import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { Headline } from "root/libs/ui-components/src";
import { DhlButton, DhlLink } from "@dhl-official/react-library";

export const CardPriceHeadline = styled(Headline)`
  margin: ${(props) => props.bottomMargin};

  @media screen and (max-width: ${breakpoints.tablet}) {
    font-size: var(--dui-size-font-3xl) !important;
    line-height: var(--dui-size-line-height-10xl) !important;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0;
  }
`;

export const CardPriceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media screen and (min-width: ${breakpoints.tablet}) {
    align-items: center;
    margin-bottom: var(--dui-size-space-4x);
  }

  @media print {
    width: 30%;
  }

  .price-label {
    color: var(--dui-color-black-500);
    margin: var(--dui-size-space-5x) 0;

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-bottom: var(--gaq-size-space-3px);
    }
  }
`;

export const CardButtonWrapper = styled.div`
  dhl-button,
  button {
    display: block;
    width: 100% !important;
  }

  @media print {
    display: none;
  }
`;

export const DisclaimerStar = styled.span`
  font-weight: 200;
`;

export const CardPriceDiscount = styled(Headline)`
  text-decoration: line-through;
  font-size: var(--dui-size-font-xs);
  line-height: 24px;
  text-align: right;

  &.L6 {
    color: var(--dui-colors-action-foreground-ghost-disabled);
  }
`;

export const StyledLink = styled(DhlLink)`
  & > dhl-button > .styled.md:is(button, a) {
    display: block;
    line-height: normal !important;
    text-align: center;
    text-decoration: none;
    min-height: auto;
    width: 100%;
    position: relative;
    font-weight: 700;
    padding: var(--gaq-size-space-9px) var(--gaq-size-space-5px) !important;
    border-radius: var(--dui-size-radius-md);
    font-size: 1.4rem !important;
    min-width: unset;
    height: unset !important;

    &:hover {
      color: var(--dui-color-white-500) !important;
    }
  }

  & > dhl-button > .styled.md.outline:is(button, a) {
    &:hover {
      color: var(--dui-color-red-500) !important;
    }
  }
`;

export const StyledButton = styled(DhlButton)`
  & > .styled.md:is(button, a) {
    display: block;
    line-height: normal !important;
    text-align: center;
    text-decoration: none;
    min-height: auto;
    width: 100%;
    position: relative;
    font-weight: 700;
    padding: var(--gaq-size-space-9px) var(--gaq-size-space-5px) !important;
    border-radius: var(--dui-size-radius-md);
    font-size: 1.4rem !important;
    min-width: unset;
    height: unset !important;
  }
`;

export const CardPayment = styled.div`
  display: flex;
  align-items: flex-start;
  height: 31px;
  margin-top: var(--dui-size-space-1x);

  & .vat-info-message {
    margin: auto 0 auto auto;
  }
`;
